import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TokenService } from 'sce-core';
import { UserService } from 'sce-core';
import { NavigationService } from 'sce-core';

@Injectable()
export class OnlyLoggedInUsersGuard implements CanActivate {

  constructor(private tokenService: TokenService,
    private userService: UserService,
    private router: Router,
    private navService: NavigationService) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.tokenService.isAuthenticatedUser()) {
      if (this.navService.appInitialized) {
        // return true if app is initialised.
        // this.navService.setMenuIdFromRoute(state.url);
        // To be removed/changed once url based breadcrumb logic is finalised
        const name = state.url.split('/');
        if (name.length > 2) {
          // this.navService.addNonNavigableBreadCrumb(name[3].toUpperCase());
          /** For urls directly routing to a menu, save the Url in navigation service */
          this.navService.directUrlNavigation = state.url
        }
        return true;
      }
      this.navService.initAppDataAndReload(state.url);
      // this.navService.initAppDataAndReload('/home');
      return false;
    } else {
      this.userService.logout();
      // this.router.navigate(['/login']);
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/guards/only-loggedin-users.guard.ts